/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_PrivacyInputs */

const en_wc_footer_privacy = /** @type {(inputs: Wc_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Wc_Footer_PrivacyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_privacy = /** @type {((inputs?: Wc_Footer_PrivacyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_PrivacyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_privacy(inputs)
});
export { wc_footer_privacy as "wc.footer.privacy" }